import axios from "axios";

async function resolve(promise) {
  let resolved = {
    data: null,
    error: null,
  };

  try {
    resolved.data = await promise;
  } catch (e) {
    resolved.error = e.response ? e.response.data : e;
  }

  return resolved;
}

export async function login(id, password) {
  let data = {
    username: id,
    password: password,
  };

  return await resolve(
    axios
      .post(window.global.server_url + "/login", data, {
        headers: {
          "content-Type": "application/json",
        },
      })
      .then((res) => res.data)
  );
}

export async function get_user() {
  return await resolve(
    axios
      .get(window.global.server_url + "/current_user", {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function logout() {
  return await resolve(
    axios
      .delete(window.global.server_url + "/logout", {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function dashboarddata() {
  return await resolve(
    axios
      .get(window.global.server_url + "/process_type", {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}
export async function get_page_creation() {
  return await resolve(
    axios
      .get(window.global.server_url + "/page_creation", {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function page_creation(data) {
  let datas = {
    page_creation: data,
  };

  return await resolve(
    axios
      .post(window.global.server_url + "/save_page_creation", datas, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function userselectedprocess(fileID) {
  let data = {
    file_id: fileID,
    type: 1,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/all_process", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function get_prev_files(process) {
  return await resolve(
    axios
      .get(window.global.server_url + "/get_files_list", {
        params: { process: process },
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function sendDataToApi(selecteddata) {
  let data = {
    file_name: selecteddata.filename,
    content: selecteddata.content,
    process: selecteddata.process,
  };
  console.log(data);

  return await resolve(
    axios
      .post(window.global.server_url + "/upload_file", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function reportValidation(value) {
  let data = {
    file_id: value.file_id,
    type: 2,
    cat: value.next_process,
  };

  return await resolve(
    axios
      .post(window.global.server_url + "/validation", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function gettagmappingdata(fileId, category) {
  let data = {
    file_id: fileId,
    type: 1,
    cat: category,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/get_tagmapping", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function sendTagmapping(fileId, apidata) {
  let data = {
    file_id: fileId,
    type: 1,
    cat: 1,
    selected_text: apidata,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/save_tagmapping", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function getepubrolemappingdata(fileId, category) {
  let data = {
    file_id: fileId,
    type: 1,
    cat: category,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/get_role_mapping", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function sendEpubRoleMappingData(fileId, apidata, category) {
  let data = {
    file_id: fileId,
    type: 1,
    cat: category,
    selected_text: apidata,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/save_rolemapping", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function getnavxhtml(fileId, category) {
  let data = {
    file_id: fileId,
    type: 1,
    cat: category,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/get_nav_xhtml", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function sendnavxhtml(fileId, guidetext, category) {
  let data = {
    file_id: fileId,
    type: 1,
    cat: category,
    selected_text: guidetext,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/save_nav_xhtml", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function getlanguagetagdata(fileId, category) {
  let data = {
    file_id: fileId,
    type: 1,
    cat: category,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/get_language_tag", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function send_language_tag(fileId, guidetext, category) {
  let data = {
    file_id: fileId,
    type: 1,
    cat: category,
    selected_text: guidetext,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/save_language_tag", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function csv_to_json(fileName, content) {
  let data = {
    file_name: fileName,
    content: content,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/csv_to_json", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function send_excel_validation(
  fileId,
  guidetext,
  category,
  fileName
) {
  let data = {
    file_id: fileId,
    file_name: fileName,
    type: 1,
    cat: category,
    content: guidetext,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/excel_validation", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function send_pageid_creation(
  fileId,
  guidetext,
  category,
  romanCount,
  fileName
) {
  let data = {
    file_id: fileId,
    type: 1,
    cat: category,
    file_name: fileName,
    roman_no: romanCount,
    content: guidetext,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/page_id", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function getmetadata(fileId, category) {
  let data = {
    file_id: fileId,
    type: 1,
    cat: category,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/get_meta_data", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function send_metadata(fileId, userdata, category) {
  let data = {
    file_id: fileId,
    type: 1,
    cat: category,
    selected_text: userdata,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/save_meta_data", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function getreport(fileId, userdata, category) {
  let data = {
    file_id: 8,
    type: 2,
    cat: 8,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/get_report", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function getdownload(fileId, process) {
  let data = {
    file_id: fileId,
    process: process,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/download_file", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function fileDelete(fileId, process) {
  let data = {
    file_id: fileId,
    process: process,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/delete_epub", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function getStage(fileId, category) {
  let data = {
    type: 1,
    file_id: fileId,
    cat: category,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "/get_previous", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function vendor_validation(file) {
  return await resolve(
    axios
      .post(window.global.server_url + "/merge_xhtml", file, {
        headers: {
          "content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function sendlatex(file) {
  const data = {
    file_name: file.filename,
    file_content: file.content,
  };

  return await resolve(
    axios
      .post(window.global.server_url + "/Latex_to_html", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function sendGripList(file) {
  const data = {
    file_name: file.filename,
    file_content: file.content,
  };

  return await resolve(
    axios
      .post(window.global.server_url + "/Griplist_validation", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}


export async function sendAutoTagPdf(file) {
  const data = {
    file_name: file.filename,
    file_content: file.content,
  };

  return await resolve(
    axios
      .post(window.global.server_url + "/autotag_pdf", data, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}